const translations = {
	page_title: "Dépôt des documents",
	input_name_label: "Nom du document",
	cta: "Ajouter le document",
	modal: {
		title: "Êtes-vous sûr ?",
		text: "Cette action est irréversible.",
		cta: "Supprimer",
	},
};

export default translations;
